import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { setSelectedQuery } from "modules/DMSv3/CustomQueries/hooks";
import { DMSv3CustomQueriesQueryKeys } from "modules/DMSv3/CustomQueries/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DMSCustomQueryHistory } from "models";

type SubmitCustomQueryPayload = {
  dealer_location_id: number;
  name: string;
  query: string;
};

export const useSubmitCustomQueryMutation = () => {
  const { user } = usePermanentRealTimeUser();

  return useTypedMutation<SubmitCustomQueryPayload, DMSCustomQueryHistory>({
    mutationFn: async payload => (await ApiInstance.post("/custom_queries/submit", payload, ENV.dmsAccessorBaseURL)).data,
    onSuccess: (_, createdQuery) => {
      const newQuery = { ...createdQuery, user };
      setSelectedQuery(newQuery);

      const history = typedQueryClient.getQueryData(DMSv3CustomQueriesQueryKeys.history);
      if (!history) return;

      typedQueryClient.setQueryData(DMSv3CustomQueriesQueryKeys.history, {
        ...history,
        items: [newQuery, ...history.items],
        nb_items: history.nb_items + 1
      });
    }
  });
};
